import { I18NextPipe } from 'angular-i18next';
import { StepType } from 'wizards/onboarding/services/steps/steps.types';

export enum StepId {
  AgentInstallation = 'agentInstallation',
  StorageAccount = 'storageAccount',
  BackupSource = 'backupSource',
  Notifications = 'notifications'
}

export const StepsConfig = (i18n: I18NextPipe): StepType<StepId>[] => {
  return [
    {
      id: StepId.AgentInstallation,
      name: i18n.transform(`wizards:onboarding.steps.agentInstallation`),
      prev: null,
      next: StepId.StorageAccount
    },
    {
      id: StepId.StorageAccount,
      name: i18n.transform(`wizards:onboarding.steps.storageAccount`),
      prev: StepId.AgentInstallation,
      next: StepId.BackupSource
    },
    {
      id: StepId.BackupSource,
      name: i18n.transform(`wizards:onboarding.steps.backupSource`),
      prev: StepId.StorageAccount,
      next: StepId.Notifications
    },
    {
      id: StepId.Notifications,
      name: i18n.transform(`wizards:onboarding.steps.notifications`),
      prev: StepId.BackupSource,
      next: null
    }
  ];
};
